export default {
  clients: ({ clients }) => clients,
};
